import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface Booking {
  id: string;
  date: string;
  duration: number;
  status: string;
  price: number;
  note?: string;
  managementToken: string;
  service: {
    id: string;
    name: string;
  };
  staff?: {
    id: string;
    name: string;
  };
}

interface CustomerAuthState {
  isAuthenticated: boolean;
  customer: any | null;
  token: string | null;
  bookings: Booking[];
  isLoadingBookings: boolean;
  login: (token: string, customer: any) => void;
  logout: () => void;
  setBookings: (bookings: Booking[]) => void;
  setLoadingBookings: (loading: boolean) => void;
}

export const useCustomerAuthStore = create<CustomerAuthState>()(
  persist(
    (set) => ({
      isAuthenticated: !!localStorage.getItem('customer_token'),
      customer: null,
      token: localStorage.getItem('customer_token'),
      bookings: [],
      isLoadingBookings: false,

      login: (token: string, customer: any) => {
        localStorage.setItem('customer_token', token);
        set({ isAuthenticated: true, customer, token });
      },

      logout: () => {
        localStorage.removeItem('customer_token');
        set({
          isAuthenticated: false,
          customer: null,
          token: null,
          bookings: []
        });
      },

      setBookings: (bookings: Booking[]) => {
        set({ bookings });
      },

      setLoadingBookings: (loading: boolean) => {
        set({ isLoadingBookings: loading });
      },
    }),
    {
      name: 'customer-auth-storage',
      partialize: (state) => ({
        customer: state.customer,
        token: state.token,
        isAuthenticated: state.isAuthenticated,
        bookings: state.bookings,
      }),
    }
  )
);
